import React from 'react';
import './button-link.styles.scss';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { IconType } from 'react-icons';

interface Props {
  label: string;
  href: string;
  Icon?: IconType;
  className?: string;
}

const ButtonLink: React.FC<Props> = ({ label, href, Icon, className }) => {
  return (
    <AnchorLink to={href} title={label} className={`button-link ${className ?? ''}`}>
      {label}
      {Icon ? <Icon className="button-link__icon" /> : null}
    </AnchorLink>
  );
};

export default ButtonLink;
